import { createContext, useState, useEffect, FC } from "react";
import API from './API';
import { useLocation, useNavigate } from "react-router-dom";
import { ContextType, CurrentUserContextType } from './interfaces';



export const UserContext = createContext<ContextType | null>(null);

const UserProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
    const [currentUser, setCurrentUser] = useState<CurrentUserContextType>({
        login: null,
        authenticated: false,
        name: null,
        surname: null,
        adminLevel: 0,
        settings: {
            showInactive: false
        },
        centerId: 0,
        divisionId: 0,
        projectManager: false,

    });
    const navigate = useNavigate();
    const location = useLocation()


    useEffect(() => {
        API.getUser().then((data) => {
            setCurrentUser({
                ...data,
                settings: {
                    showInactive: false
                }
            })
        }).catch((err) => {
            console.log(location.pathname);

            if (location.pathname !== '/login') {
                navigate("/login");
            }
        })
    }, []);


    if (!currentUser && location.pathname !== '/login') {
        return <div>Loading...</div>
    }


    return (
        <UserContext.Provider value={{ currentUser, setCurrentUser }}>
            {children}
        </UserContext.Provider>
    );
};

export default UserProvider;
